import { Component, OnChanges, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PipelineDetailsDto, AccountableFunctionLink2Dto, AccountableFunctionDto, FunctionDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { AccountablefxnpopupComponent } from '../../accountablefxnpopup/accountablefxnpopup.component';

@Component({
  selector: 'cradua-accountablefunction',
  templateUrl: './accountablefunction.component.html',
  styleUrls: ['./accountablefunction.component.scss']
})
export class AccountablefunctionComponent implements OnChanges {
 
  accountablefunctionlinkForm: FormGroup;
  @Input() selectedPipelineDetails: PipelineDetailsDto;
  @Input() acountablefunctionlink2s: AccountableFunctionLink2Dto[];
  @Input() accountablefunctions: AccountableFunctionDto[];
  @Input() functions: FunctionDto[];
  @Input() pipelinedetails: any[];
  @Output() emitSave = new EventEmitter<AccountableFunctionLink2Dto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Input() isLoadingAcountablefunctionlink2s: boolean;
  // @ViewChild(LandParcellationTableComponent) child: LandParcellationTableComponent;
  AccountList: any[] = [];
  selectedId: any;
  filteredDelete: Array<any> =[];
  listView = true;
  gridView = false;

  constructor(private fb: FormBuilder, public dialog: MatDialog) { }

  ngOnChanges(): void {
    this.accountablefunctionlinkForm = this.fb.group({AccountableFunctions: this.fb.array([])});
    if(this.acountablefunctionlink2s != null && this.acountablefunctionlink2s.length) {
      this.setAccountableFunctionLink(this.acountablefunctionlink2s);
  
    }
  }

   setAccountableFunctionLink(accountableFunctionLink2s: AccountableFunctionLink2Dto[]) {
    accountableFunctionLink2s.forEach(value => {
      this.control().push(this.fb.group({
          AccountableFunctionName: value.AccountableFunctionName,
          FunctionName: value.FunctionName,
          FunctionalEmail: value.FunctionalEmail,
          AutoSerialId: value.AutoSerialId,
          SubscriberId: value.SubscriberId,
          SubscriptionUserId: value.SubscriptionUserId,
          id: value.id
        })
      );
     });
   }

   control() {
     return this.accountablefunctionlinkForm.controls.AccountableFunctions as FormArray;
   }

   public errorHandling = (control: string, error: string) => {
    return this.accountablefunctionlinkForm.controls[control].hasError(error);
  };

  onCreate() {
    this.accountablefunctionlinkForm.reset();
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  onPopUpDisplay(event) {
    const listdata = [];

    event.map(dat => {
      const data  = {
        FunctionName: "", 
        AccountableFunctionName: dat.AccountableFunctionName,
        FunctionalEmail: dat.FunctionalEmail,
        FunctionId: dat.FunctionId,
        AutoSerialId: this.selectedPipelineDetails.id,
        SubscriberId: dat.SubscriberId,
        SubscriptionUserId: dat.SubscriptionUserId,
      };
      const functions =  this.functions.find(fxn => fxn.id === dat.FunctionId);
      if(functions) {
        data.FunctionName = functions.FunctionName
      }

      listdata.push(data);

    });

    const dialogRef = this.dialog
      .open(AccountablefxnpopupComponent, {
        data: listdata,
        height: 'auto',
        width: '900px'
      })
      .afterClosed()
      .subscribe(data => {
        if(data) {
          data.forEach(e => {
            this.control().push(this.fb.group(e));
          });
        }
      });
  }

  onPatchValue(value) {
    this.accountablefunctionlinkForm.patchValue({
      AccountableFunctionName: value.AccountableFunctionName,
      FunctionName: value.FunctionName,
      FunctionalEmail: value.FunctionalEmail,
      id: value.id
    });
  }

  getPipeline(id) {
    return this.pipelinedetails.find(pipeline => pipeline.PipelineCode === id);
  }

  onDelete(value, index) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.control().removeAt(index);
        for ( let i = 0; i < this.acountablefunctionlink2s.length; i++) {
            if (i === index) {
              if (value.id !== null) {
                this.filteredDelete.push(this.acountablefunctionlink2s[i].id);
                console.log('deleted data: ', this.filteredDelete);
                this.deleteEvent.emit(this.filteredDelete);
                this.filteredDelete = [];
              }

            }
          }
        
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: AccountableFunctionLink2Dto) {
    // formValue.AutoSerialId = this.selectedPipelineDetails.id;
    // formValue.SubscriberId = this.selectedPipelineDetails.SubscriberId;
    // formValue.SubscriptionUserId = this.selectedPipelineDetails.SubscriptionUserId;
    if(this.accountablefunctionlinkForm.valid){
      this.emitSave.emit(formValue['AccountableFunctions']);
    }
  }
}
